/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Columnmenu_Hide1Inputs */

const en_columnmenu_hide1 = /** @type {(inputs: Columnmenu_Hide1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide`)
};

const de_columnmenu_hide1 = /** @type {(inputs: Columnmenu_Hide1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausblenden`)
};

/**
* | output |
* | --- |
* | "Hide" |
*
* @param {Columnmenu_Hide1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const columnmenu_hide1 = /** @type {((inputs?: Columnmenu_Hide1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Columnmenu_Hide1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_columnmenu_hide1(inputs)
	return de_columnmenu_hide1(inputs)
});
export { columnmenu_hide1 as "columnMenu_hide" }